var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-scale-transition', [_vm.show ? _c('div', {
    staticClass: "pdf-wrapper"
  }, [_c('client-needs-generator', {
    attrs: {
      "applicant": _vm.applicant,
      "coApplicant": _vm.coApplicant,
      "properties": _vm.properties,
      "mortgage": _vm.mortgage,
      "broker": _vm.broker
    }
  })], 1) : _vm._e()]);

}
var staticRenderFns = []

export { render, staticRenderFns }